/*
 * The AfterShip returns app renders inside a shadow root attached to #MainContent,
 * so theme stylesheets cannot reach it. This injects our layout overrides directly
 * into that shadow root. Selectors avoid the app's hashed class names: the hero box
 * is matched through the scroll container it wraps.
 */
class AftershipReturnsStyles {
    constructor() {
        this.hostSelector   = '#MainContent';
        this.styleAttribute = 'data-fiz-returns';
        this.pollInterval   = 100;
        this.pollTimeout    = 20000;
        this.css = `
            .returns-app div:has(> [class*="atta-scroll-container"]) {
                height: 100dvh !important;
                padding-top: calc(var(--fiz-announceBar-height) + var(--fiz-header-height) + (2 * 16px)) !important;
                box-sizing: border-box !important;
            }
        `;
    }
    start() {
        if (this.inject()) return;

        const startedAt = Date.now();
        const timer = setInterval(() => {
            if (this.inject() || Date.now() - startedAt > this.pollTimeout) {
                clearInterval(timer);
            }
        }, this.pollInterval);
    }
    inject() {
        const shadowRoot = document.querySelector(this.hostSelector)?.shadowRoot;
        if (!shadowRoot) return false;
        if (shadowRoot.querySelector(`style[${this.styleAttribute}]`)) return true;

        const style = document.createElement('style');
        style.setAttribute(this.styleAttribute, '');
        style.textContent = this.css;
        shadowRoot.appendChild(style);
        return true;
    }
}

new AftershipReturnsStyles().start();
